module.exports = __webpack_public_path__ + "media/images/admin/icons/crop-cfaa0f803bed5fb9ae47e47f515e4499.svg";